import { connect } from 'react-redux';

import { requestSignUpOtp, resetMeta, resetPage } from '../../actions/SignUpPage';
import { getPublishedEvent } from '../../actions/LoginPage';
import SignUpPage from './SignUpPage';

const mapsStateToProps = state => ({
	signUpPageProps: state.signUpPageReducer,
	loginPageProps: state.loginPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getPublishedEvent() {
		dispatch(getPublishedEvent());
	},
	requestSignUpOtp(options) {
		dispatch(requestSignUpOtp(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(SignUpPage);
